import { LoadingSection } from "components/LoadingSection";
import { useGetOutstandingInvoicesQuery } from "queries/billingApi";
import { expireTime } from "queries/queries.utils";
import React from "react";
import { useAppSelector } from "reduxUtils/hook";
import { INVOICED_PAYMENT_STATUSES } from "utils/constants";
import { jwtClient } from "utils/jwtClient";

import { OutstandingBillListItem } from "./OutstandingBillListItem";

export const OutstandingBillsList: React.FC = () => {
  const { customerNumber } = useAppSelector((store) => store.currentAccount);

  const {
    isFetching: isOutstandingInvoicesFetching,
    data: outstandingInvoices = [],
  } = useGetOutstandingInvoicesQuery(
    { jwtClient, customerNumber: customerNumber },
    {
      skip: !customerNumber,
      refetchOnMountOrArgChange: expireTime,
    },
  );

  if (isOutstandingInvoicesFetching) {
    return <LoadingSection />;
  }

  if (outstandingInvoices.length === 0) {
    return <></>;
  }

  return (
    <nav>
      <ul className="customer_tools_list">
        <li className="customer_tools_list__title">Outstanding bills</li>

        {outstandingInvoices.length > 0 &&
          outstandingInvoices?.map((outstandingInvoice, i) => (
            <li
              className="customer_tools_list__item customer_tools_list__item--text-no-margin customer_tools_list__item--wrap"
              key={`invoice-${outstandingInvoice.attributes.number}`}
            >
              <OutstandingBillListItem invoice={outstandingInvoice} key={i} />
            </li>
          ))}
      </ul>
    </nav>
  );
};
